import React from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import { data } from "../data.js";
import Project from "../components/Project";
import HorizontalSpace from "../components/HorizontalSpace";
import VerticalSpace from "../components/VerticalSpace";
import ShowAllButton from "../components/ShowAllButton";
import ProjectList from "../components/ProjectList";
import Heading from "../components/Heading";

const projectsWithRole = (role) =>
  data.projects
    .filter((project) => project.roles.includes(role))
    .map((project) => (
      <Project
        metadata={project}
        highlightRole={role}
        key={Date.now() + project.title}
      />
    ));

const RoleName = styled.span`
  color: ${({ theme }) => theme.highlight};
  text-transform: capitalize;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const RoleView = () => {
  const { roleName } = useParams();
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Row>
        <Heading>
          Role: <RoleName>{roleName}</RoleName>
        </Heading>
        <HorizontalSpace $amount={10} />
        <ShowAllButton type={"button"} onClick={() => navigate("/")} />
      </Row>
      <VerticalSpace $amount={20} />
      <ProjectList>{projectsWithRole(roleName)}</ProjectList>
    </React.Fragment>
  );
};

export default RoleView;
